import { SGeneralForms, SLocalTreeSelected } from 'shj-components'
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { Select, TreeSelect } from 'antd'
import { trimStr } from '@/utils/data.ts'
import { getChildrenDicts } from '@/services'
import { useSetState } from 'ahooks'
import _ from 'lodash'

type IProps = {
  fn: () => void
  setSubmitLoading: (v: boolean) => void
  spaceList: any[]
  companyList: any[]
  dataSource: any[]
  record: any
}

export const AddOrEditCategory = forwardRef((props: IProps, ref) => {
  const { companyList = [], dataSource = [], record } = props
  const [optionList, setOptionList] = useState([{ id: '0', name: '通用' }, ...companyList])

  const formRef = useRef()

  const [state, setState] = useSetState<any>({
    copyDisabled: false,
  })

  const spaceList = useMemo((): any[] => {
    if (record.spaceTag && props.spaceList) {
      return (
        props.spaceList?.map(item => {
          const item_ = { ...item }
          if (item.priKey === record.spaceTag) {
            item_.disabled = false
          }
          return item_
        }) || []
      )
    }
    return props.spaceList || []
  }, [props.spaceList, record])

  const options = useMemo(() => {
    return dataSource?.map(item => ({ ...item })).filter(item => item.id !== record.id)
  }, [dataSource])

  useEffect(() => {
    onFormRef()?.resetFields()
    onFormRef()?.setFieldsValue({
      ...record,
      shops: record.shops,
      parentId: record.parentId == '0' ? null : record.parentId,
    })
    shopsControl(record.shops)
  }, [record])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const getShopArr = codeArr => {
    // if (codeArr.length === 1 && codeArr[0] === '0') return [{id: '0', name: '通用'}]
    return optionList.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, companyName: item.name })
      return res
    }, [])
  }

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      onFormRef()
        ?.validateFields()
        .then(values => {
          props.setSubmitLoading?.(true)
          const shopList = getShopArr(values.shops || [])
          resolve({
            ...values,
            id: record.id,
            shopList: shopList,
            shops: values.shops,
            parentId: values.parentId || '0',
            oldParentId: record.parentId || '0',
            level: record.level || 0,
            busType: 'PRD_CATE',
            busTypeName: '分类',
            children: record.children || null,
          })
        })
    })
  }
  const shopsControl = (value: any) => {
    let newOption: any = _.cloneDeep(optionList)
    if (value?.length) {
      if (value.includes('0')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id !== '0',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id === '0',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setOptionList(newOption)
  }
  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])

  return (
    <>
      <SGeneralForms
        ref={formRef}
        isHideGobackBtn={true}
        // httpOptionsFn={getOptions}
        layout="vertical"
        titleMode={'edit'}
        initialValues={{ isCopy: true, isShowOrder: true }}
        configs={[
          {
            title: '基础信息',
            formItem: [
              {
                name: 'parentId',
                label: '上级分类',
                spanCol: 24,
                children: (
                  <Select
                    options={options}
                    allowClear
                    placeholder={'请选择上级分类'}
                    fieldNames={{ label: 'dtlName', value: 'id' }}
                  />
                ),
              },
              {
                name: 'dtlName',
                label: '分类名称',
                required: true,
                rules: [{ required: true, message: '分类名称不能为空' }],
                spanCol: 24,
                comConfig: {
                  showCount: true,
                  maxLength: 15,
                  onChange: e => onFormRef()?.setFieldValue('dtlName', trimStr(e.target.value)),
                },
              },
            ],
          },
          {
            title: '显示配置',
            formItem: [
              {
                name: 'isShowOrder',
                label: '下单时是否显示',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
            ],
          },
          {
            title: '适用渠道',
            formItem: [
              {
                name: 'shops',
                label: '适用门店',
                spanCol: 24,
                children: (
                  <Select
                    optionFilterProp={'name'}
                    placeholder={'请选择适用门店'}
                    mode={'multiple'}
                    onChange={(value, option) => {
                      shopsControl(value)
                    }}
                    fieldNames={{ label: 'name', value: 'id' }}
                    options={optionList}
                  />
                ),
              },
            ],
          },
        ]}
      />
    </>
  )
})
